import {io} from 'socket.io-client';
// import axios from 'axios';
import {appConfig} from '@config';

export type IResponse<T> = {
	success: true;
	result: T
} | {
	success: false,
	error: string
};


let socketCompetition = io(appConfig.socketCompetition.url, {
	auth: {
		token: localStorage.getItem('rezvan_token')
	},
	autoConnect: false,
	reconnectionAttempts: 5,
	reconnectionDelay: 1000,
	timeout: 30000,
	retries: 5
	// ackTimeout: 100000
});
export default socketCompetition;

socketCompetition.on('connect', () => {
	// console.log('connect to competition');
});

socketCompetition.on('connect_error', (err) => {
	// console.log(err);
});

// // set connect timer to 5 seconds
// socketCompetition._connectTimer = setTimeout(function() {
// 	socketCompetition.close();
// }, 5000);
//
// socketCompetition.on('connect', function() {
// 	// socket connected successfully, clear the timer
// 	clearTimeout(socketCompetition._connectTimer);
// });

// socketCompetition.on('connect_error', (err) => {
// 	if (err.message === 'User isn\'t login') {
// 		axios({
// 			url: `${appConfig.base.url}user`,
// 			method: 'post'
// 		}).then(res => {
// 			localStorage.setItem('rezvan_token', res.data.result);
// 			// @ts-ignore
// 			socketCompetition.auth.token = res.data.result;
// 			socketCompetition.connect();
// 		}).catch(err => {
// 			console.log(err);
// 		});
// 	}
// });
